const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    width: "32px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4E276"
    },
    d: "M372.364,349.091c-51.33,0-93.091-41.761-93.091-93.091s41.761-93.091,93.091-93.091 c12.853,0,23.273-10.42,23.273-23.273c0-12.853-10.42-23.273-23.273-23.273H139.636C62.641,116.364,0,179.005,0,256 s62.641,139.636,139.636,139.636h232.727c12.853,0,23.273-10.42,23.273-23.273S385.216,349.091,372.364,349.091z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 372.364,
    cy: 256,
    r: 116.364
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9A8AE"
    },
    d: "M372.364,395.636c-76.995,0-139.636-62.641-139.636-139.636s62.641-139.636,139.636-139.636 S512,179.005,512,256S449.359,395.636,372.364,395.636z M372.364,162.909c-51.33,0-93.091,41.761-93.091,93.091 s41.761,93.091,93.091,93.091S465.455,307.33,465.455,256S423.694,162.909,372.364,162.909z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switch-on.389bab7e.svg";
export { ForwardRef as ReactComponent };